<div
  class="simple-carousel"
  [style.marginTop.px]="marginService.getCurrentMargin(margin)"
>
  <h2 class="title" *ngIf="section.heading">{{ section.heading }}</h2>
  <swiper [config]="swiperOpt" class="slider-main">
    <ng-template swiperSlide *ngFor="let block of section.blocks">
      <div class="item">
        <div class="image-wrapper">
          <app-img
            [src]="block.imageLink"
            [height]="block.imageHeight"
            [width]="block.imageWidth"
            [index]="0"
          ></app-img>
        </div>
        <h5 class="heading" *ngIf="block.heading">{{ block.heading }}</h5>
      </div>
    </ng-template>
  </swiper>
</div>
